import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FileDropzone from '../components/FileDropzone';

const Email: React.FC = () => {
    const [menuClosed, setMenuClosed] = useState(false);

    useEffect(() => {
        document.body.classList.toggle('innermenu-close', menuClosed);
        return () => {
            document.body.classList.remove('innermenu-close');
        };
    }, [menuClosed]);

    const innersidebar = () => {
        setMenuClosed(prev => !prev);
    };

    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Email Inbox</h6>
                        <p className="text-secondary small">Stay up to date with communication</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter">
                            <i className="bi bi-funnel"></i>
                        </button>
                        <button className="btn btn-square btn-theme ms-1" type="button" data-bs-toggle="modal" data-bs-target="#emailcompose">
                            <i className="bi bi-envelope-plus align-middle"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page">Email</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <ul className="nav rounded mb-2">
                    <li className="nav-item">
                        <button className="btn btn-link btn-square innersidebar-btn" onClick={innersidebar}>
                            <i className="bi bi-layout-sidebar h5 align-middle"></i>
                        </button>
                    </li>
                    <li className="nav-item">
                        <div className="nav-link px-lg-3">
                            <input className="form-check-input align-middle mt-0 me-1" type="checkbox" value="" aria-label="..." defaultChecked /> All
                        </div>
                    </li>
                    <li className="nav-item d-none d-lg-block">
                        <a className="nav-link px-lg-3" ><i className="bi bi-arrow-clockwise h5 align-middle"></i></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link px-lg-3" ><i className="bi bi-trash align-middle"></i></a>
                    </li>
                    <li className="nav-item ms-auto">
                        <a className="nav-link" ><i className="bi bi-question-circle"></i></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link d-inline-block" ><i className="bi bi-chevron-left"></i></a>
                        <a className="nav-link d-inline-block" ><i className="bi bi-chevron-right"></i></a>
                    </li>
                </ul>

                <div className="inner-sidebar-wrap">
                    <div className="inner-sidebar height-dynamic bg-transparent" style={{ "--h-dynamic": "auto" } as React.CSSProperties}>
                        <div className="card adminuiux-card h-100">
                            <div className="card-body">
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" placeholder="Search mail... " value="" />
                                    <button className="btn border" type="button">
                                        <i className="bi bi-search"></i>
                                    </button>
                                </div>
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a className="nav-link active" aria-current="page" href="investment-inbox.html">
                                            <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-inbox"></i></div>
                                            <div className="col">Inbox</div>
                                            <div className="col-auto align-self-center">
                                                <figure className="avatar avatar-28 coverimg rounded-circle">
                                                    <img src={asset('assets/img/adminuiux/user-4.jpg')} alt="" />
                                                </figure>
                                                <figure className="avatar avatar-28 coverimg rounded-circle">
                                                    <img src={asset('assets/img/adminuiux/user-1.jpg')} alt="" />
                                                </figure>
                                                <figure className="avatar avatar-28 bg-theme-1 rounded-circle">
                                                    <small>9+</small>
                                                </figure>
                                            </div>
                                        </a>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="false" data-bs-display="static" role="button" aria-expanded="false">
                                            <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-tags"></i></div>
                                            <div className="col">Categories</div>
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <a className="dropdown-item nav-link" >
                                                    <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-inbox-fill"></i>
                                                    </div>
                                                    <div className="col align-self-center">Important</div>
                                                    <div className="col-auto align-items-center">
                                                        <span className="badge text-bg-primary mx-2">9+</span>
                                                    </div>
                                                    <div className="arrow"><i className="bi bi-chevron-right"></i></div>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="dropdown-item nav-link" >
                                                    <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-people"></i>
                                                    </div>
                                                    <div className="col align-self-center">Social</div>
                                                    <div className="arrow"><i className="bi bi-chevron-right"></i></div>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="dropdown-item nav-link" >
                                                    <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-cart"></i>
                                                    </div>
                                                    <div className="col align-self-center">eCommerce</div>
                                                    <div className="arrow"><i className="bi bi-chevron-right"></i></div>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="dropdown-item nav-link" >
                                                    <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-megaphone"></i>
                                                    </div>
                                                    <div className="col align-self-center">Marketing</div>
                                                    <div className="arrow"><i className="bi bi-chevron-right"></i></div>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="dropdown-item nav-link" >
                                                    <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-chat-right-dots"></i>
                                                    </div>
                                                    <div className="col align-self-center">Forum</div>
                                                    <div className="arrow"><i className="bi bi-chevron-right"></i></div>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" aria-current="page" >
                                            <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-clock"></i></div>
                                            <div className="col">Snoozed</div>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" aria-current="page" >
                                            <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-star"></i></div>
                                            <div className="col">Favorite</div>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" aria-current="page" >
                                            <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-send"></i></div>
                                            <div className="col">Sent</div>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" aria-current="page" >
                                            <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-save"></i></div>
                                            <div className="col">Draft</div>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" aria-current="page" >
                                            <div className="avatar avatar-28 icon rounded-circle"><i className="bi bi-exclamation-circle"></i></div>
                                            <div className="col">Spam</div>
                                            <div className="col-auto">
                                                <span className="badge text-bg-warning mx-2">99+</span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="inner-sidebar-content">
                        <div className="list-group adminuiux-list-group list-group-flush hover-highlight-list bg-none">
                            <div className="list-group-item new">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-yellow align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4" data-bs-toggle="modal" data-bs-target="#emailread">
                                        <p className="mb-0">Max Smith, Zeel Smith</p>
                                        <p className="text-secondary text-truncated">Online Survey for ew project we have started!</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5" data-bs-toggle="modal" data-bs-target="#emailread">
                                        <p className="mb-1 small">Feb 22
                                            <span className="text-secondary">8:00pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item new">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-secondary  align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4" data-bs-toggle="modal" data-bs-target="#emailread">
                                        <p className="mb-0">
                                            Shelvey Doe
                                        </p>
                                        <p className="text-secondary text-truncated">Start course you have subscribed.</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5" data-bs-toggle="modal" data-bs-target="#emailread">
                                        <p className="mb-1 small">Feb 20
                                            <span className="text-secondary">6:45pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-secondary  align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4" data-bs-toggle="modal" data-bs-target="#emailread">
                                        <p className="mb-0">Maria Johnson</p>
                                        <p className="text-secondary text-truncated">Start course you have subscribed.</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5" data-bs-toggle="modal" data-bs-target="#emailread">
                                        <p className="mb-1 small">Feb 20
                                            <span className="text-secondary">6:45pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-secondary  align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4" data-bs-toggle="modal" data-bs-target="#emailread">
                                        <p className="mb-0">Jack Daniel</p>
                                        <p className="text-secondary text-truncated">Your Behance portfolio updated recently</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5" data-bs-toggle="modal" data-bs-target="#emailread">
                                        <p className="mb-1 small">Feb 18
                                            <span className="text-secondary">12:00pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-yellow align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4">
                                        <p className="mb-0">Dhiren Nagar</p>
                                        <p className="text-secondary text-truncated">Welcome to the team adminuiux your are the most awaited player.
                                        </p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5">
                                        <p className="mb-1 small">Feb 18
                                            <span className="text-secondary">11:00am</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-yellow align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4">
                                        <p className="mb-0">Max Smith, Zeel Smith</p>
                                        <p className="text-secondary text-truncated">Online Survey for ew project we have started!</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5">
                                        <p className="mb-1 small">Feb 22
                                            <span className="text-secondary">8:00pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-secondary  align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4">
                                        <p className="mb-0">
                                            Shelvey Doe
                                        </p>
                                        <p className="text-secondary text-truncated">Start course you have subscribed.</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5">
                                        <p className="mb-1 small">Feb 20
                                            <span className="text-secondary">6:45pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-secondary  align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4">
                                        <p className="mb-0">Jack Daniel</p>
                                        <p className="text-secondary text-truncated">Your Behance portfolio updated recently</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5">
                                        <p className="mb-1 small">Feb 18
                                            <span className="text-secondary">12:00pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-yellow align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4">
                                        <p className="mb-0">Dhiren Nagar</p>
                                        <p className="text-secondary text-truncated">Welcome to the team adminuiux your are the most awaited player.
                                        </p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5">
                                        <p className="mb-1 small">Feb 18
                                            <span className="text-secondary">11:00am</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-yellow align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4">
                                        <p className="mb-0">Max Smith, Zeel Smith</p>
                                        <p className="text-secondary text-truncated">Online Survey for ew project we have started!</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5">
                                        <p className="mb-0">Feb 22
                                            <span className="text-secondary">8:00pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-secondary  align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4">
                                        <p className="mb-0">
                                            Shelvey Doe
                                        </p>
                                        <p className="text-secondary text-truncated">Start course you have subscribed.</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5">
                                        <p className="mb-1 small">Feb 20
                                            <span className="text-secondary">6:45pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="list-group-item">
                                <div className="row gx-3">
                                    <div className="col-auto align-self-center order-1 order-md-1">
                                        <input className="form-check-input me-1" type="checkbox" value="" />
                                    </div>
                                    <div className="col-auto order-2 order-md-2 align-self-center"><i className="bi bi-star text-secondary align-middle"></i></div>
                                    <div className="col-auto order-3 order-md-3 align-self-center"><i className="bi bi-flag text-secondary  align-middle"></i></div>
                                    <div className="col-12 col-md order-5 order-md-4">
                                        <p className="mb-0">Jack Daniel</p>
                                        <p className="text-secondary text-truncated">Your Behance portfolio updated recently</p>
                                    </div>
                                    <div className="col-auto text-end ms-auto ms-md-0 order-4 order-md-5">
                                        <p className="mb-1 small">Feb 18
                                            <span className="text-secondary">12:00pm</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* modal compose email */}
            <div className="modal fade adminuiux-modal" id="emailcompose" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered ">
                    <div className="modal-content">
                        <div className="modal-header">
                            <p className="h6">Create New Email</p>
                        </div>
                        <div className="modal-body d-block">

                            {/* Title */}
                            <div className="form-floating mb-3">
                                <input type="text" className="form-control" id="sendto" placeholder="Select Send to" value="cotact@testmail.com" />
                                <label htmlFor="sendto">Send to</label>
                            </div>

                            {/* Title */}
                            <div className="form-floating mb-3">
                                <input type="text" className="form-control" id="subject" placeholder="Subject" value="DevUIUX template for your all need for business" />
                                <label htmlFor="subject">Subject</label>
                            </div>

                            {/* Textarea */}
                            <h6 className="mb-3">Your Message</h6>
                            <textarea className='form-control mb-3'>
                                This is best interface design template I have ever seen.
                                I am really very impressed of work, flexibility, extensibility and elasticity across devices.
                                Its awesome and I really appreciate this.
                            </textarea>

                            {/* dropzone */}
                            <h6 className="mb-3">Attachments</h6>
                            <FileDropzone
                                id="myDropzone2"
                                maxFileSize={6}
                                acceptedFiles=".jpeg,.jpg,.png,.mp4,.mpeg4"
                                onFilesAdded={(files) => console.log('Compose files:', files)}
                            />

                            <p className="text-secondary small">Upload only .jpeg, .png, .mp4, .mpeg4 file format max. file
                                size 6MB</p>

                            <div className="row gx-3 mt-3">
                                <div className="col">
                                    <button className="btn btn-link theme-red" type="button" data-bs-dismiss="modal"><i className="bi bi-trash h4 me-2"></i> Discard</button>
                                </div>
                                <div className="col-auto">
                                    <button className="btn btn-theme" type="button"><i className="bi bi-send me-2"></i> Send</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* modal read email */}
            <div className="modal fade adminuiux-modal" id="emailread" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable ">
                    <div className="modal-content">
                        <div className="modal-header border-bottom">
                            <div className="w-100">
                                <ul className="nav w-100 mb-3">
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-dismiss="modal"><i className="bi bi-arrow-left"></i></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link theme-red" ><i className="bi bi-trash align-middle"></i></a>
                                    </li>
                                    <li className="nav-item d-none d-sm-block">
                                        <a className="nav-link" ><i className="bi bi-reply h5"></i></a>
                                    </li>
                                    <li className="nav-item ms-auto">
                                        <a className="nav-link" ><i className="bi bi-star text-secondary align-middle"></i></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" ><i className="bi bi-flag-fill text-yellow align-middle"></i></a>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link text-secondary " data-bs-toggle="dropdown" aria-expanded="false" data-bs-display="static" role="button">
                                            <i className="bi bi-three-dots-vertical"></i>
                                        </a>
                                        <ul className="dropdown-menu dropdown-menu-end">
                                            <li><a className="dropdown-item" href="javascript:void(0)">Mark as read</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0)">Junk</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0)">Spam</a></li>
                                            <li><a className="dropdown-item text-danger" href="javascript:void(0)">Report</a></li>
                                        </ul>
                                    </li>
                                </ul>

                                {/* sender */}
                                <div className="row gx-3">
                                    <div className="col-3 col-sm-auto align-self-center">
                                        <div className="avatar avatar-60 rounded-circle coverimg">
                                            <img src={asset('assets/img/adminuiux/user-2.jpg')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-9 col-sm ">
                                        <h6 className="mb-0">Shelvey Doe</h6>
                                        <p className="text-truncate mb-0">shelvey.shen@gmailtest.com</p>
                                        <p className="text-secondary small">Feb 20 <span>6:45pm</span></p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-body d-block">
                            {/* subject */}
                            <p className="mb-1 text-secondary small">Subject</p>
                            <h5>This is awesome product & I am very happy with delivery & product packaging.</h5>
                            <hr />

                            {/* mail content  */}
                            <div>
                                <p>Hello InvestmentUX and Team,</p>
                                <p className="h6">"Greetings from DevUIUX"</p>
                                <br />
                                <p>This is awesome product and, I am very happy with delivery &amp; product is awesome product and, I am very happy with delivery &amp; product packaging Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    Pellentesque eleifend Lorem ipsum dolor sit</p>

                                <p>Lipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend Lorem ipsum dolor sit amet, consectetur adipiscing elit. </p>
                                <br />
                                <figure className="text-center">
                                    <blockquote className="blockquote">
                                        <p> This is awesome product &amp; I am very happy with delivery &amp; product packaging.</p>
                                    </blockquote>
                                    <figcaption className="blockquote-footer">
                                        Team Lead <cite title="Source Title">DevUIUX</cite>
                                    </figcaption>
                                </figure>
                                <br />
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend</p>

                                <p>Thanks,</p>

                                <p className="h6">John Smith</p>
                                <p>CEO-Apples Solution</p>
                            </div>

                            <hr />
                            {/* Textarea */}
                            <div className="text-center mb-3 mb-lg-4">
                                <h4 className="mb-0 text-center text-gradient d-inline-block mx-auto">Your reply</h4>
                                <p className="text-secondary text-center">Communication is key of generate leads</p>
                            </div>
                            <textarea className="form-control mb-3">
                                This is best interface design template I have ever seen.
                                I am really very impressed of work, flexibility, extensibility and elasticity across devices. Its awesome and I really appreciate this.
                            </textarea>

                            {/* dropzone */}
                            <h6 className="mb-3">Attachments</h6>
                            <FileDropzone
                                id="myDropzone1"
                                maxFileSize={6}
                                acceptedFiles=".jpeg,.jpg,.png,.mp4,.mpeg4"
                                onFilesAdded={(files) => console.log('Reply files:', files)}
                            />

                            <p className="text-secondary small">Upload only .jpeg, .png, .mp4, .mpeg4 file format max. file
                                size 6MB</p>

                            <div className="row gx-3 mt-3">
                                <div className="col">
                                    <button className="btn btn-link theme-red" type="button" data-bs-dismiss="modal"><i className="bi bi-trash h4 me-2"></i> Discard</button>
                                </div>
                                <div className="col-auto">
                                    <button className="btn btn-theme" type="button"><i className="bi bi-send me-2"></i> Reply</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Email;
